import React from 'react';
import { WithTestIdOptional } from 'shared-client/types/test';
import { toKebabCase } from 'util/StringUtil';
import OptionalFieldMarker from '../OptionalFieldMarker';

interface SimpleCheckboxProps extends WithTestIdOptional {
	label: string;
	checked: boolean;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	ariaLabel?: string;
	id: string;
	name: string;
	light?: boolean;
	wrapperClass?: string;
	// #region HCL
	isRequired?: boolean;
	// //#endregion
}

/**
 * Component that renders an input with form field.
 */
export default function SimpleCheckbox({
	id,
	checked,
	onChange,
	name,
	testId,
	light,
	label,
	wrapperClass,
	// #region HCL
	isRequired = false,
}: // #endRegion
SimpleCheckboxProps) {
	return (
		<div className={`roc-checkbox-simple ${wrapperClass ? wrapperClass : ''}`}>
			<label className="roc-checkbox-simple__item" htmlFor={id}>
				<input
					checked={checked}
					value="true"
					onChange={onChange}
					type="checkbox"
					className="roc-checkbox-simple__item-input"
					id={id}
					name={name}
					data-testid={testId || `field-${toKebabCase(name)}`}
					// #region HCL
					required={isRequired}
					// #endRegion
				/>

				<span className="roc-checkbox-simple__item-faux-checkmark" />
				<span className="roc-checkbox-simple__item-text">
					<span
						className={
							'roc-checkbox-simple__item-label' + (light ? ' roc-checkbox-simple__item-label--light' : '')
						}
					>
						{label}
						{/* #region HCL */}
						{!isRequired ? <OptionalFieldMarker /> : null}
						{/* #endregion */}
					</span>
				</span>
			</label>
		</div>
	);
}

SimpleCheckbox.defaultProps = {
	light: false,
};
